/**
 * Pure helpers for API auth behavior (R3: 401 → redirect to /login).
 * Extracted for unit testing without loading axios (Phase 3).
 */

/**
 * Determines if a 401 response should trigger redirect to login (R3).
 * @param {number} status - HTTP status
 * @param {string} requestUrl - Full request URL (baseURL + url)
 * @param {string} pathname - window.location.pathname
 * @returns {boolean}
 */
export function shouldRedirectToLoginOn401(status, requestUrl, pathname, search = '') {
  if (status !== 401) return false;
  const isLoginRequest =
    (requestUrl || '').includes('/token') ||
    (requestUrl || '').includes('/login') ||
    (requestUrl || '').includes('/auth/demo-magic-consume');
  const params = new URLSearchParams(search || '');
  const isDemoSignIn =
    Boolean(params.get('tenant')?.trim()) || Boolean(params.get('magic')?.trim());
  const isOnLoginPage =
    pathname === '/login' ||
    pathname === '/' ||
    (pathname === '/index.html' && isDemoSignIn);
  return !isLoginRequest && !isOnLoginPage;
}
